import React, { useState } from 'react'
import "../../components/dataTable/datatable.scss"
import { Link } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';
import useFetch from '../../hooks/useFetch'
import { useEffect } from 'react';
import { axiosInstance } from '../../config';
import { useDispatch } from 'react-redux';
import { active } from '../../redux/dataSlice4';
import Spinner from '../../components/spinner';

const columns = [
    {
        field: 'name',
        headerName: 'Name',
        width: 250,
    },
    { field: 'email', headerName: 'Email', width: 250 },
    { field: 'createdAt', headerName: 'Date', type: 'date', width: 150 },
    {
        field: 'isVerified',
        headerName: 'Status',
        width: 150,
        renderCell: (params) =>{
            return (<div className={`cellWithStatus ${params.row.isVerified}`}>{params.row.isVerified}</div>);
        }
    },
];

const ReviewList = () => {

    const [list, setList] = useState();
    const [loading, setLoading] = useState(true);
    const { data } = useFetch("/review-form/")
    const dispatch = useDispatch();
    
    useEffect(() => {
        setList(data);
        setLoading(false);
    },[data])

    const handleDelete = async (id) => {
        try{
            await axiosInstance.delete(`/review-form/${id}`)
            setList(list.filter((item) => item._id !== id))
        }catch(err){
            console.log(err);
        }
    }

    const handleView = async (id) => {
        try{
            const single = await axiosInstance.get(`/review-form/${id}`)
            dispatch(active(single.data));
        }catch(err){
            console.log(err);
        }
    }

    const actionColumn = [
        {
            field: "action",
            headerName: "Action",
            width: 200,
            renderCell: (params)=>{
                return(
                    <div className='cellAction'>
                        <Link to={`${params.row._id}`} style={{textDecoration:'none'}}>
                            {/* <div className='viewBtn'>VIEW</div> */}
                            <div className='viewBtn' onClick={async() => await handleView(params.row._id)}>VIEW</div>
                        </Link>
                        <div className='deleteBtn' onClick={() => handleDelete(params.row._id)}>DELETE</div>
                    </div>
                )
            }
        }
    ]
  return (
    <div className='data-table'>
        {
            loading && <Spinner/>
        }
        
        { !loading && <DataGrid
            className='dataGrid'
            rows = {list}
            columns={columns.concat(actionColumn)}
            pageSize={10}
            rowsPerPageOptions={[10]}
            getRowId={row => row._id}
        />}
    </div>
  )
}

export default ReviewList